import { ComponentWrapperHOC } from "../../components/WrapperHoc";
import s from "./input.module.scss";
import { ButtonSize } from "../../sharedTypes/components";
import Select, { StylesConfig } from "react-select";
// import "react-phone-number-input/style.css";

type OptionType = { readonly label: string; readonly value: string | number };

interface Props {
  label?: string;
  labelStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  fullwidth?: boolean;
  lowerText?: string;
  sizing?: ButtonSize;
  value: string | number | OptionType;
  name?: string;
  required?: boolean;
  width?: string;
  height?: string;
  placeholder?: string;
  options: OptionType[];
  changeFn?: (name: string, value: OptionType | string | number) => void;
}

export function SelectField(props: Props) {
  const {
    containerStyle,
    label,
    labelStyle,
    required,
    fullwidth = true,
    width = "auto",
    height,
    sizing,
    value,
    name,
    lowerText,
    changeFn,
    // ...rest
  } = props;

  const handleChange = (selectedOption: OptionType | unknown) => {
    if (
      typeof selectedOption === "object" &&
      selectedOption !== null &&
      "value" in selectedOption
    ) {
      const option = selectedOption as OptionType;
      changeFn && changeFn(name || "", option.value || "");
    }
  };

  const wrapperWidth = fullwidth ? "100%" : width;
  const style: StylesConfig = {
    control: (base) => ({
      ...base,
      height: height ? height : "48px",
      boxShadow: "0 !important",
      backgroundColor: "#F9FBFC",
      border: "1px solid #E1E6ED",
      color: "#848F9F",
      width: 100 + "%",
      "&:hover": {
        backgroundColor: "#F3F5F6",
        color: "#848F9F",
      },
      tabIndex: 1,
    }),
    option: (styles) => {
      return {
        ...styles,
        color: "#353F50",
        backgroundColor: "transparent",
        lineHeight: "1.5em",
        display: "flex",
        alignItems: "center",
        zIndex: 100,
        "&:hover": {
          backgroundColor: "#F7FCFF",
          color: "#480500",
        },
      };
    },
  };
  return (
    <ComponentWrapperHOC
      wrap={!!label}
      wrapper={(children:any) => (
        <label style={{ width: wrapperWidth, ...labelStyle }} className={s.label}>
          {label && (
            <span>
              {label}
              {required ? <sup className={s.required}>*</sup> : null}
            </span>
          )}
          {children}
        </label>
      )}
    >
      <div
        className={
          "tw-w-full tw-flex tw-flex-col tw-gap-[5px]" +
          [s["form-input"], sizing && s[sizing]].join(" ")
        }
        style={{ ...containerStyle }}
      >
        <Select
          isMulti={false}
          // inputId={props.id}
          className="basic-single w-full"
          placeholder={props.placeholder}
          options={props.options}
          value={{
            value: value,
            label: props.options.filter((item) => item.value === value)[0]?.label,
          }}
          onChange={handleChange}
          styles={style}
          components={{
            IndicatorSeparator: () => null,
          }}
        />
        {lowerText && (
          <p className="tw-text-[.75em] tw-font-[400] tw-text-neutral-700 tw-capitalize">
            {lowerText}
          </p>
        )}
      </div>
    </ComponentWrapperHOC>
  );
}
